/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Members of the careteam involved in this approach
 */
export class CareTeamMembership {
  constructor(json: JSON | any) {
    Object.assign(this as CareTeamMembership, json)
  }

  startDate?: number
  endDate?: number
  careTeamMemberId?: string
  membershipType?: CareTeamMembership.MembershipTypeEnum
  /**
   * The base64 encoded data of this object, formatted as JSON and encrypted in AES using the random master key from encryptionKeys.
   */
  encryptedSelf?: string
}
export namespace CareTeamMembership {
  export type MembershipTypeEnum = 'doctor' | 'mutuality' | 'patient' | 'specialist' | 'other'
  export const MembershipTypeEnum = {
    Doctor: 'doctor' as MembershipTypeEnum,
    Mutuality: 'mutuality' as MembershipTypeEnum,
    Patient: 'patient' as MembershipTypeEnum,
    Specialist: 'specialist' as MembershipTypeEnum,
    Other: 'other' as MembershipTypeEnum,
  }
}
